<template>
    <div class="content-wrapper book_submission">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.book.bookSubmission')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.book.bookSubmission')}}</div>
                        <button class="btn btn-primary float-right" @click="submission()">{{$t('button.save')}}</button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="StudentField">{{$t('form.book.studentName')}}<span
                                            class="text-danger">*</span></label>
                                    <input id="StudentField" v-model.trim="$v.student.Name.$model"
                                        :placeholder="$t('form.book.searchStudent')" type="text"
                                        @keyup="searchStudent()" class="form-control"
                                        :class="{ 'is-invalid': $v.student.Name.$error }">
                                    <div class="invalid-feedback" v-if="!$v.student.Name.required">
                                        {{$t('form.validation.required')}}</div>
                                    <ul class="list-group m-0">
                                        <li class="list-group-item" v-for="(std,index) in students" v-bind:key='index'
                                            @click="selectedStudent(std)">
                                            <a style="cursor:pointer">{{std.StudentNumber}} - {{std.FirstName}} {{std.LastName}}</a>
                                        </li>
                                    </ul>
                                </div>

                                <div class="form-group">
                                    <label for="NumberField">{{$t('form.book.studentNumber')}}</label>
                                    <input id="NumberField" type="text" class="form-control"
                                        v-model="student.StudentNumber" disabled>
                                </div>

                                <div class="form-group">
                                    <label for="BirthDateField">{{$t('form.book.birthDate')}}</label>
                                    <input id="BirthDateField" type="text" v-model="student.BirthDate"
                                        class="form-control" disabled>
                                </div>

                                <div class="form-group">
                                    <label for="BirthPlaceField">{{$t('form.book.birthPlace')}}</label>
                                    <input id="BirthPlaceField" v-model="student.BirthPlace" type="text"
                                        class="form-control" disabled>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>{{$t('form.book.bookBundle')}}</th>
                                                <th>{{$t('form.book.print')}}</th>
                                                <th class="text-right">
                                                    <input type="button" class="btn btn-sm btn-primary"
                                                        @click="addBookBundle()" :value="$t('button.add')">
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(bb,index) in selectedBookBundles" v-bind:key="index">
                                                <td>
                                                    <v-select label="Description" :options="bookBundles" v-model="bb.ID"
                                                        :reduce="bookBundles => bookBundles.ID">
                                                    </v-select>
                                                </td>

                                                <td>
                                                    <input type="checkbox" v-model="bb.Print">
                                                </td>

                                                <td class="text-right">
                                                    <button class="btn btn-danger btn-sm"
                                                        @click="removeBookBundle(index)">
                                                        <i class="fa fa-times"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12">
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>{{$t('form.book.book')}}</th>
                                                <th>{{$t('form.book.dateReceived')}}</th>
                                                <th class="text-right">
                                                    <input type="button" class="btn btn-primary btn-sm"
                                                        @click="addBook()" :value="$t('button.add')">
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(b,index) in selectedBooks" v-bind:key="index">
                                                <td>
                                                    <v-select :options="books"  :reduce="books => books.ID" label="Label"  v-model="b.ID"
                                                       >
                                                    </v-select>
                                                </td>
                                                <td>
                                                    <input type="date" v-model="b.TakingDate" class="form-control">
                                                </td>
                                                <td class="text-right">
                                                    <button class="btn btn-danger btn-sm" @click="removeBook(index)">
                                                        <i class="fa fa-times"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        required,
    } from "vuelidate/lib/validators";

    export default {
        props: ['permissions', 'dateFormat'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                request_source: '',

                student: {
                    StudentNumber: null,
                    BirthPlace: null,
                    BirthDate: null,
                    Name: null,
                    ID: null,
                },

                selectedBooks: [],
                selectedBookBundles: [],
                students: [],
                books: [],
                bookBundles: []
            }
        },

        validations: {
            student: {
                Name: {
                    required
                }
            }
        },

        mounted() {
            if (!this.permissions.createBooksSubmissions) {
                this.$router.push('/');
                return;
            }

            this.getBooks();
            this.getBookBundles();
               
        },

        methods: {

            searchStudent() {

                if (this.student.Name == '') {
                    this.clear();
                    return;
                }

                let source = axios.CancelToken.source();

                if (this.request_source != '')
                    this.request_source.cancel('Operation canceled by the user.');

                this.request_source = source;

                axios
                    .get(`/api/students?name=${this.student.Name}`, {
                        cancelToken: this.request_source.token
                    })
                    .then(response => this.students = response.data.data.data)
                    .catch(error => console.log('error'));
            },

            selectedStudent(std) {
                this.student.StudentNumber = std.StudentNumber;
                this.student.BirthPlace = std.BirthPlace;
                this.student.BirthDate = this.$options.filters.formatDate(std.BirthDate, this.dateFormat);
                this.student.Name = `${std.FirstName} ${std.LastName}`;
                this.student.ID = std.ID;

                this.clear();
            },

            clear() {
                this.students = [];
            },

            getBooks() {
                axios
                    .get('/api/books?full')
                    .then(response => 
                    {
                        this.books = response.data.map(function (book){
                            return {ID:book.ID, Label: book.Title + ' - ' + book.Edition}
                        }); 
                    })
                    .catch(error => console.log('error'));
            },

            addBook() {
                this.selectedBooks.push({
                    ID: null,
                    TakingDate: moment().format('YYYY-MM-DD')
                });
            },

            removeBook(index) {
                this.selectedBooks.splice(index, 1);
            },

            getBookBundles() {
                axios
                    .get('/api/bookbundles?full')
                    .then(response => this.bookBundles = response.data)
                    .catch(error => console.log('error'));
            },

            addBookBundle() {
                this.selectedBookBundles.push({
                    ID: null,
                    Print: null,
                });
            },

            removeBookBundle(index) {
                this.selectedBookBundles.splice(index, 1);
            },

            submission() {

                this.$v.$touch();

                if (this.$v.$invalid) {
                    this.showAlert(this.$t('form.validation.error'), 'danger');
                    return;
                }

                const formData = new FormData();

                formData.append('student', JSON.stringify(this.student));
                this.selectedBooks.forEach(b => formData.append('books[]', JSON.stringify(b)));
                this.selectedBookBundles.forEach(bb => formData.append('bundleList[]', JSON.stringify(bb)));

                this.isLoading = true;

                axios
                    .post('/api/submissions', formData)
                    .then(response => {
                        this.isLoading = false;

                        if (response.data.error) {
                            this.showAlert(response.data.message, 'danger');
                        } else if (response.data.error_book) {
                            this.showAlert(response.data.message, 'danger');
                        } else if (response.data.success) {
                            this.showAlert(response.data.message);

                            setTimeout(() => {
                                this.$router.push({
                                    name:'viewEditSubmissions'
                                });
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    })
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    }

</script>
<style>
    .searchCourseBackground:hover {
        background: #eee;
    }

    .v-select ul.vs__dropdown-menu {
        margin: 0 !important;
    }

    .book_submission .v-select ul.vs__dropdown-menu {
        position: relative !important;
    }

    .v-select {
        background: #fff;
    }

</style>
